// src/pages/AnmeldePage.js
import React, { useState } from 'react';
import BetaForm from '../components/BetaForm';
import SubmissionSuccess from '../components/SubmissionSuccess';

const AnmeldePage = () => {
    const [submitted, setSubmitted] = useState(false);

    const handleFormSuccess = () => {
        setSubmitted(true);
    };

    return submitted ? <SubmissionSuccess /> : <BetaForm onSuccess={handleFormSuccess} />;
};

export default AnmeldePage;